export const styles = () => ({
  modal: { height: '450px', width: '660px', alignSelf: 'center' },
  paperContainer: { flexGrow: 1 }
});
